const ITEM_ROW_HEIGHT = 88;
const ITEM_CARD_HEIGHT = undefined;
const ITEM_CARD_PADDING = 4;
const HOUR_BLOCK_WIDTH = 120;

export const rosterConfig = {
  CONTENT_PANEL_WIDTH: 280,
  GROUP_ROW_HEIGHT: 10,
  FOOTER_BLOCK_HEIGHT: 18,
  SIDEBAR_WIDTH: 216,
  WEEKLY_HOUR_BLOCK_HEIGHT: 64,
  WEEKLY_HOUR_BLOCK_WIDTH: 120,
  WEEKLY_ROW_HEIGHT: 88,
  WEEKLY_CARD_HEIGHT: undefined,
  WEEKLY_CARD_PADDING: 4,
  TIMELINE_HOUR_BLOCK_HEIGHT: 34,
  TIMELINE_HOUR_BLOCK_WIDTH: HOUR_BLOCK_WIDTH * 2,
  TIMELINE_ROW_HEIGHT: ITEM_ROW_HEIGHT,
  TIMELINE_CARD_HEIGHT: ITEM_CARD_HEIGHT,
  TIMELINE_CARD_PADDING: ITEM_CARD_PADDING,
  TIMELINE_CONTENT_GROUP_HEIGHT: 56,
  grayColor: 'rgb(251,251,251)',
  backgroundColor: 'rgb(253,253,253)',
};
